// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ORxv","colMin":"styles_colMin__3CXjS"};